import { EventEmitter } from "events";
import { ElaborationMessage } from "../../redux/feature/object/remote-elaborations-slice";
import { v4 as uuid } from "uuid";

export interface NotificationToastToAdd {
  key?: string;
  message: string;
  title: string;
  closable?: boolean;
  removeOnClose?: boolean;
  isTemporary?: boolean;
  type?: "success" | "error" | "warning" | "info";
  closed?: boolean;
  details?: ElaborationMessage[];
  onClose?: () => void;
  priority?: number;
  startShowing?: number;
  enableReloadPanel?: boolean;
}

export interface NotificationToast {
  key: string;
  message: string;
  title: string;
  type: "none" | "success" | "error" | "warning" | "info";
  closable: boolean;
  removeOnClose: boolean;
  closed?: boolean;
  details?: ElaborationMessage[];
  onClose?: () => void;
  priority?: number;
  startShowing: number;
  isTemporary: boolean;
  enableReloadPanel?: boolean;
}

class NotificationManager extends EventEmitter {
  constructor() {
    super();
    this.listNotify = [];
  }

  listNotify: NotificationToast[];

  addNotification(detail: NotificationToastToAdd) {
    const isAlreadyPresent = detail.key && this.listNotify.find((n) => n.key === detail.key) !== undefined;

    const notification: NotificationToast = {
      key: detail.key ?? uuid(),
      type: detail.type || "info",
      startShowing: detail.startShowing ?? new Date().getTime(),
      closable: detail.closable ?? true,
      removeOnClose: true,
      isTemporary: true,
      ...detail,
    };

    if (notification.priority || isAlreadyPresent) {
      this.remove(notification.key, false);
      this.listNotify.unshift(notification);
    } else {
      this.listNotify.push(notification);
    }
    this.emitChange();
  }

  remove(key: string, update?: boolean) {
    this.listNotify = this.listNotify.filter((n) => key !== n.key);
    if (update === undefined || update === true) this.emitChange();
  }

  emitChange() {
    this.emit("CHANGE", this.listNotify);
  }

  addChangeListener(callback) {
    this.addListener("CHANGE", callback);
  }

  removeChangeListener(callback) {
    this.removeListener("CHANGE", callback);
  }
}

export default new NotificationManager();
